// Sugerencias y errores: lo que comparten el botón 💬 de las barras y la
// pantalla de Sistema (ver server/current/feedback).

export type FeedbackKind = "ERROR" | "SUGERENCIA";
export type FeedbackStatus = "NUEVO" | "REVISADO" | "RESUELTO" | "DESCARTADO";

export const FEEDBACK_MAX_MESSAGE = 2000;

export const KIND_LABEL: Record<FeedbackKind, string> = {
  ERROR: "Error",
  SUGERENCIA: "Sugerencia",
};
export const KIND_ICON: Record<FeedbackKind, string> = {
  ERROR: "🐞",
  SUGERENCIA: "💡",
};
export const STATUS_LABEL: Record<FeedbackStatus, string> = {
  NUEVO: "Nuevos",
  REVISADO: "Revisados",
  RESUELTO: "Resueltos",
  DESCARTADO: "Descartados",
};
export const ROL_LABEL: Record<string, string> = {
  ADMIN: "Admin",
  SELLER: "Tienda",
  DRIVER: "Chofer",
  PROVIDER: "Proveedor",
};

// La captura viaja como JPEG de 1600 px como máximo (~200-400 KB): una foto
// del celular o un PNG de pantalla completa pesan diez veces más y el
// servidor corta en 2 MB. Fondo blanco porque JPEG no tiene transparencia.
export async function shrinkImage(file: Blob, max = 1600, quality = 0.8): Promise<string> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error("No se pudo leer la imagen"));
      i.src = url;
    });
    const scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("No se pudo procesar la imagen");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/jpeg", quality);
  } finally {
    URL.revokeObjectURL(url);
  }
}
